(function () {
  'use strict';

  var KEY = 'vybe_wishlist';
  var drawer = null;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('vybe:wishlist:change', { detail: { items: items } }));
  }

  function has(id) {
    return read().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function toggle(product) {
    var items = read();
    var id = String(product.id);
    var exists = items.some(function (item) {
      return String(item.id) === id;
    });
    if (exists) {
      items = items.filter(function (item) {
        return String(item.id) !== id;
      });
    } else {
      items.unshift(product);
    }
    write(items);
    return !exists;
  }

  function money(cents) {
    if (cents == null || cents === '') return '';
    var value = Number(cents) / 100;
    if (Number.isNaN(value)) return String(cents);
    return '₹' + value.toLocaleString('en-IN');
  }

  function productFromButton(btn) {
    return {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-handle'),
      title: btn.getAttribute('data-title'),
      url: btn.getAttribute('data-url'),
      image: btn.getAttribute('data-image') || '',
      price: btn.getAttribute('data-price') || '',
      compare: btn.getAttribute('data-compare') || '',
    };
  }

  function syncButtons() {
    document.querySelectorAll('[data-vybe-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var on = has(id);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? 'Remove from wishlist' : 'Add to wishlist';
      btn.setAttribute('aria-label', label);
      var text = btn.querySelector('[data-vybe-wishlist-label]');
      if (text) text.textContent = on ? 'Saved' : 'Wishlist';
    });
    var count = read().length;
    document.querySelectorAll('[data-vybe-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  function renderDrawer() {
    if (!drawer) return;
    var list = drawer.querySelector('[data-vybe-wishlist-list]');
    var empty = drawer.querySelector('[data-vybe-wishlist-empty]');
    var items = read();
    if (!items.length) {
      list.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    list.innerHTML = items
      .map(function (item) {
        var price = item.price ? '<span class="vybe-wish-drawer__price">' + money(item.price) + '</span>' : '';
        var img = item.image
          ? '<img src="' + item.image + '" alt="" width="72" height="72">'
          : '<span class="vybe-wish-drawer__ph"></span>';
        return (
          '<article class="vybe-wish-drawer__item">' +
          '<a class="vybe-wish-drawer__media" href="' +
          (item.url || '/products/' + item.handle) +
          '">' +
          img +
          '</a>' +
          '<div class="vybe-wish-drawer__meta">' +
          '<a href="' +
          (item.url || '/products/' + item.handle) +
          '">' +
          (item.title || '') +
          '</a>' +
          price +
          '</div>' +
          '<button type="button" class="vybe-wish-drawer__remove" data-vybe-wishlist-remove="' +
          item.id +
          '" aria-label="Remove">×</button>' +
          '</article>'
        );
      })
      .join('');
  }

  function openDrawer(e) {
    if (e) e.preventDefault();
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vybe-wishlist-open');
    renderDrawer();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vybe-wishlist-open');
  }

  function onClick(e) {
    var trigger = e.target.closest('[data-vybe-wishlist-open]');
    if (trigger) {
      openDrawer(e);
      return;
    }
    if (e.target.closest('[data-vybe-wishlist-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var remove = e.target.closest('[data-vybe-wishlist-remove]');
    if (remove) {
      e.preventDefault();
      write(
        read().filter(function (item) {
          return String(item.id) !== String(remove.getAttribute('data-vybe-wishlist-remove'));
        })
      );
      return;
    }
    var btn = e.target.closest('[data-vybe-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(productFromButton(btn));
  }

  document.addEventListener('click', onClick);
  document.addEventListener('vybe:wishlist:change', function () {
    syncButtons();
    renderDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function init() {
    drawer = document.querySelector('[data-vybe-wishlist-drawer]');
    syncButtons();
    if (document.body && document.body.getAttribute('data-template') === 'page.wishlist') {
      var pageRoot = document.querySelector('[data-vybe-wishlist-page]');
      if (pageRoot) renderPage(pageRoot);
    }
  }

  function renderPage(root) {
    var list = root.querySelector('[data-vybe-wishlist-list]');
    var empty = root.querySelector('[data-vybe-wishlist-empty]');
    var items = read();
    if (!items.length) {
      list.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    list.innerHTML = items
      .map(function (item) {
        return (
          '<a class="vybe-wish-page__card" href="' +
          (item.url || '/products/' + item.handle) +
          '">' +
          (item.image ? '<img src="' + item.image + '" alt="' + (item.title || '') + '">' : '') +
          '<h3>' +
          (item.title || '') +
          '</h3>' +
          (item.price ? '<p>' + money(item.price) + '</p>' : '') +
          '</a>'
        );
      })
      .join('');
  }

  document.addEventListener('vybe:wishlist:change', function () {
    var pageRoot = document.querySelector('[data-vybe-wishlist-page]');
    if (pageRoot) renderPage(pageRoot);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
